import request from '@/utils/request'
import { IPoint, RecordStatus, LeakStatus, FileType, ILeakFile, RepairType } from './types'

// 漏水点相关接口
// 创建漏水点
export function CreateLeak(params: {
  index: string
  roadInfo: string
  size: number
  material: string
  location: IPoint
  referenceAddr: string
  detailAddr: string
  checkUserId: number
  ProjectId: number
  files?: {
    filePath: string
    fileType: FileType
  }[]
}) {
  return request({
    url: '/leaks',
    method: 'post',
    data: params
  })
}

// 获取漏水点详情
export function GetLeakById(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}`,
    method: 'get'
  })
}

// 获取漏水点列表
export function ListLeaks(params?: {
  status?: LeakStatus[]
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  createTimeStart?: string
  createTimeEnd?:string
  reportTimeStart?: string
  reportTimeEnd?: string
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  simple?: boolean
  repairTypes?: RepairType[]
  page?: number
  pageSize?: number
}) {
  return request({
    url: '/leaks',
    method: 'get',
    params
  })
}

// 查找附近的漏水点
export function FindNearbyLeaks(params: {
  longitude: number
  latitude: number
  radius: number
}) {
  return request({
    url: '/leaks/nearby',
    method: 'get',
    params
  })
}

// 上报漏水点
export function ReportLeak(params: {
  id: number
  roadInfo: string
  size: number
  material: string
  detailAddr: string
  files?: {
    filePath: string
    fileType: FileType
  }[]
}) {
  const { id, ...data } = params
  return request({
    url: `/leaks/${id}/report`,
    method: 'post',
    data
  })
}

// 撤销上报
export function CancelReport(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}/cancel-report`,
    method: 'post'
  })
}

// 标记为内部维修
export function MarkAsInternalRepair(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}/mark-as-internal-repair`,
    method: 'post'
  })
}

// 结束维修
export function EndRepair(params: {
  id: number
  repairType: number
  part: string
  reason: string
  leakLeakage: number
  depth: number
  roadInfo: string
  size: number
  material: string
  files?: {
    filePath: string
    fileType: FileType
  }[]
}) {
  const { id, ...data } = params
  return request({
    url: `/leaks/${id}/end`,
    method: 'post',
    data
  })
}

// 撤销结束维修
export function CancelEndRepair(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}/cancel-end`,
    method: 'post'
  })
}

// 分配维修部门
export function AssignRepairDept(params: {
  id: number
  deptId: number
}) {
  const { id, ...data } = params
  return request({
    url: `/leaks/${id}/assign-dept`,
    method: 'post',
    data
  })
}

// 撤销维修部门
export function CancelAssignRepairDept(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}/cancel-assign-dept`,
    method: 'post'
  })
}

// 分配维修人员
export function AssignRepairUser(params: {
  id: number
  userId: number
}) {
  const { id, ...data } = params
  return request({
    url: `/leaks/${id}/assign-user`,
    method: 'post',
    data
  })
}

// 撤销分配维修人员
export function CancelAssignRepairUser(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}/cancel-assign-user`,
    method: 'post'
  })
}

// 批量分配维修部门
export function BatchAssignRepairDept(params: {
  leakIds: number[]
  deptId: number
}) {
  return request({
    url: '/leaks/batch-assign-dept',
    method: 'post',
    data: params
  })
}

// 批量分配维修人员
export function BatchAssignRepairUser(params: {
  leakIds: number[]
  userId: number
}) {
  return request({
    url: '/leaks/batch-assign-user',
    method: 'post',
    data: params
  })
}

// 更新检测信息
export function UpdateLeakDetection(params: {
  id: number
  roadInfo?: string
  size?: number
  material?: string
  detailAddr?: string
  files?: {
    filePath: string
    fileType: FileType
  }[]
}) {
  const { id, ...data } = params
  return request({
    url: `/leaks/${id}/detection`,
    method: 'post',
    data
  })
}

// 删除漏点
export function DeleteLeak(params: { id: number }) {
  return request({
    url: `/leaks/${params.id}`,
    method: 'delete'
  })
}

// 更新维修信息
export function UpdateLeakRepair(params: {
  id: number
  repairType?: number
  part?: string
  reason?: string
  leakLeakage?: number
  depth?: number
  roadInfo?: string
  size?: number
  material?: string
  files?: {
    filePath: string
    fileType: FileType
  }[]
}) {
  const { id, ...data } = params
  return request({
    url: `/leaks/${id}/repair`,
    method: 'post',
    data
  })
}

// 获取文件上传凭证
export function GetUploadCredentials(params?: {
  leakId: number
  fileType: FileType
  fileNames: string[]
}) {
  return request({
    url: '/leaks/upload-credentials',
    method: 'post',
    data: params
  })
}

// // 获取漏点文件列表
// export function GetLeakFiles(params: {
//   leakId: number
//   fileType?: FileType
// }) {
//   return request({
//     url: '/leaks/files',
//     method: 'get',
//     params
//   })
// }

// // 上传漏点文件
// export function UploadLeakFile(params: {
//   leakId: number
//   fileType: FileType
//   file: File
// }) {
//   const formData = new FormData()
//   formData.append('leakId', params.leakId.toString())
//   formData.append('fileType', params.fileType.toString())
//   formData.append('file', params.file)

//   return request({
//     url: '/leaks/files',
//     method: 'post',
//     data: formData,
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     }
//   })
// }

// // 删除漏点文件
// export function DeleteLeakFile(params: {
//   fileId: number
// }) {
//   return request({
//     url: `/leaks/files/${params.fileId}`,
//     method: 'delete'
//   })
// }

// 获取地图API密钥
export function GetMapKey() {
  return request({
    url: '/leaks/map-key',
    method: 'get'
  })
}

// 获取建议编号
export function GenerateLeakIndex(params: {
  deptId: number
}) {
  return request({
    url: '/leaks/generate-index',
    method: 'post',
    data: params
  })
}

// 统计指标相关的特殊查询接口 --------------------

// 获取今天和昨天的日期字符串
function getDateStrings() {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  return {
    todayStr: `${formatDate(today)}T23:59:59Z`,
    yesterdayStr: `${formatDate(yesterday)}T23:59:59Z`,
    yearStartStr: `${today.getFullYear()}-01-01T00:00:00Z`
  };
}

// 1. 截止昨日未上报（用createtime计算）
export function ListLeaksUnreportedUntilYesterday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { yesterdayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [LeakStatus.Unreported],
    createTimeStart: yearStartStr,
    createTimeEnd: yesterdayStr
  });
}

// 2. 截止今日未上报（用createtime计算）
export function ListLeaksUnreportedUntilToday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { todayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [LeakStatus.Unreported],
    createTimeStart: yearStartStr,
    createTimeEnd: todayStr
  });
}

// 3. 截止昨日已上报（用createtime计算）
export function ListLeaksReportedUntilYesterday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { yesterdayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [
      LeakStatus.NeedAssignRepairDept,
      LeakStatus.NeedAssignRepairUser,
      LeakStatus.Repairing,
      LeakStatus.Repaired,
      LeakStatus.CantRepair,
      LeakStatus.NoNeedRepair
    ],
    createTimeStart: yearStartStr,
    createTimeEnd: yesterdayStr
  });
}

// 4. 截止今日已上报（用createtime计算）
export function ListLeaksReportedUntilToday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { todayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [
      LeakStatus.NeedAssignRepairDept,
      LeakStatus.NeedAssignRepairUser,
      LeakStatus.Repairing,
      LeakStatus.Repaired,
      LeakStatus.CantRepair,
      LeakStatus.NoNeedRepair
    ],
    createTimeStart: yearStartStr,
    createTimeEnd: todayStr
  });
}

// 5. 截止昨日全部状态（用createtime计算）
export function ListLeaksAllStatusUntilYesterday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { yesterdayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    createTimeStart: yearStartStr,
    createTimeEnd: yesterdayStr
  });
}

// 6. 截止今日全部状态（用createtime计算）
export function ListLeaksAllStatusUntilToday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { todayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    createTimeStart: yearStartStr,
    createTimeEnd: todayStr
  });
}

// 7. 截止昨日维修中状态（用createtime计算）
export function ListLeaksRepairingUntilYesterday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { yesterdayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [LeakStatus.Repairing],
    createTimeStart: yearStartStr,
    createTimeEnd: yesterdayStr
  });
}

// 8. 截止今日维修中状态（用createtime计算）
export function ListLeaksRepairingUntilToday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { todayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [LeakStatus.Repairing],
    createTimeStart: yearStartStr,
    createTimeEnd: todayStr
  });
}

// 9. 截止昨日已维修或者无需维修或者无法维修状态（用createtime计算）
export function ListLeaksCompletedUntilYesterday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { yesterdayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [
      LeakStatus.Repaired,
      LeakStatus.NoNeedRepair,
      LeakStatus.CantRepair
    ],
    createTimeStart: yearStartStr,
    createTimeEnd: yesterdayStr
  });
}

// 10. 截止今日已维修或者无需维修或者无法维修状态（用createtime计算）
export function ListLeaksCompletedUntilToday(params?: {
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectIds?: number[]
  projectStatus?: RecordStatus[]
  page?: number
  pageSize?: number
}) {
  const { todayStr, yearStartStr } = getDateStrings();
  return ListLeaks({
    ...params,
    status: [
      LeakStatus.Repaired,
      LeakStatus.NoNeedRepair,
      LeakStatus.CantRepair
    ],
    createTimeStart: yearStartStr,
    createTimeEnd: todayStr
  });
}

// 获取排名数据
export function GetRanking(params?: {
  startTime?: string
  endTime?: string
  projectIds?: number[]
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  leakStatuses?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  reportTimeStart?: string
  reportTimeEnd?: string
  repairTimeStart?: string
  repairTimeEnd?: string
  repairTypes?: number[]
  projectStatuses?: number[]
  checkSizes?: number[]
  repairSizes?: number[]
  repairMaterials?: string[]
  checkSize?: boolean
  repairSize?: boolean
  checkMaterial?: boolean
  repairMaterial?: boolean
  checkRoadInfo?: boolean
  repairRoadInfo?: boolean
  leakLeakage?: boolean
  part?: boolean
  checkDept?: boolean
  repairDept?: boolean
  checkUser?: boolean
  repairUser?: boolean
}) {
  return request({
    url: '/leaks/ranking',
    method: 'get',
    params
  })
}

// 获取今年以来的检测管径排名
export function GetCheckSizeRanking(params?: {
  projectIds?: number[]
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  leakStatuses?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectStatuses?: number[]
}) {
  const { yearStartStr } = getDateStrings();
  return GetRanking({
    ...params,
    startTime: yearStartStr,
    checkSize: true
  });
}

// 获取今年以来的维修管径排名
export function GetRepairSizeRanking(params?: {
  projectIds?: number[]
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  leakStatuses?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectStatuses?: number[]
}) {
  const { yearStartStr } = getDateStrings();
  return GetRanking({
    ...params,
    startTime: yearStartStr,
    repairSize: true
  });
}

// 获取今年以来的维修材料排名
export function GetRepairMaterialRanking(params?: {
  projectIds?: number[]
  checkDeptIds?: number[]
  repairDeptIds?: number[]
  checkUserIds?: number[]
  repairUserIds?: number[]
  leakStatuses?: number[]
  keywords?: string[]
  addressKeywords?: string[]
  projectStatuses?: number[]
}) {
  const { yearStartStr } = getDateStrings();
  return GetRanking({
    ...params,
    startTime: yearStartStr,
    repairMaterial: true
  });
}
